import { useMutation, useQueryClient } from '@tanstack/react-query';
import { produce } from 'immer';
import { generateGroupInfoQueryOptions } from '@/hooks/groups/use-group-info';
import type { RespondedType, ResponseError } from '@/models/response';
import { addToast } from '@/stores/toast';
import { fetcher } from '@/utils/fetcher';

export default function useSetGroupNickname(groupId: Nullable<number>) {
  const queryClient = useQueryClient();

  return useMutation<RespondedType, ResponseError, string>({
    mutationKey: ['/GroupUserSetName', groupId],
    mutationFn: (params) =>
      fetcher(
        '/GroupUserSetName',
        {
          GroupID: groupId,
          MemberName: params,
        },
        { validResponseCodes: [0] },
      ),
    onSuccess: (_, params) => {
      queryClient.setQueryData(generateGroupInfoQueryOptions(groupId).queryKey, (state) =>
        produce(state, (draft) => {
          if (draft?.Self) {
            draft.Self.GroupMemberName = params;
          }

          return draft;
        }),
      );
    },
    onSettled: (data, error) =>
      addToast({
        type: data ? 'success' : 'error',
        message: data?.Msg ?? error?.message,
      }),
  });
}
